export default "__VITE_ASSET__c5933ea0__"